<div class="fs-2 with-close" mat-dialog-title>
    Nouvelle vidéo Youtube
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p [innerHTML]="video.description | nl2br"></p>
    <a href="{{ video.link }}" target="_blank">
        <img class="w-100" src="{{video.image}}" alt="Nouvelle vidéo Youtube"/>
    </a>
</div>
<div mat-dialog-actions>
    <a href="{{ video.link }}" target="_blank" class="btn w-100 btn-primary">
        Voir la vidéo
    </a>
</div>
